(ns frontend.ui.component.file-input.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [border-width color]]
   [garden.util :refer [space-join]]))

(defn file-status
  []
  {:box-shadow       "0 1px 3px 0 rgba(119,119,119,0.4)"
   :background-color (theme/color [:file-input :file-status :bg])
   :padding          "12px"
   :margin-bottom    "4px"
   :border-radius    "3px"})

(defn file-name
  []
  {:display     "flex"
   :align-items "center"
   :color       (theme/color [:file-input :file-name])})

(defn file-name-icon
  []
  {:margin-right "4px"})

(defn progress-bar-container
  []
  {:width            "100%"
   :background-color (theme/color [:file-input :progress-bar-container :bg])
   :color            (theme/color [:file-input :progress-bar-container :fg])
   :border-radius    "16px"
   ;; Clips the fill to the track.
   :overflow         "hidden"
   :position         "relative"
   :font-size        "12px"})

(defn progress-bar
  "The coloured fill; the label is a sibling over the track."
  [percents]
  {:width            (str percents "%")
   :height           "100%"
   :position         "absolute"
   :top              "0"
   :left             "0"
   ;; No radius here - it bulged out when narrow.
   ;; Transition keeps stepped progress from looking stalled.
   :transition       "width 300ms ease-out"
   :background-color (theme/color [:file-input :progress-bar :bg])})

(defn progress-bar-description
  []
  ;; Single line: wrapping grew the bar taller.
  {:position      "relative"
   :display       "block"
   :padding       "3px 8px"
   :line-height   "1.4"
   :white-space   "nowrap"
   :overflow      "hidden"
   :text-overflow "ellipsis"})

(defn input
  []
  {:display "none"})

(defn file-input
  []
  {:display          "flex"
   :justify-content  "center"
   :align-items      "center"
   :height           "60px"
   :border-radius    "3px"
   :margin-top       "8px"
   :cursor           "pointer"
   :color            (theme/color [:file-input :file-input :fg])
   :background-color (theme/color [:file-input :file-input :bg])
   :border           (space-join [(border-width :medium)
                                  "dashed"
                                  (theme/color [:file-input :file-input :border])])
   :padding          "0 5px 0 5px"})

(defn file-input-icon
  []
  {:color        (theme/color [:file-input :file-input-icon :fg])
   :margin-right "8px"
   :font-size    "24px"})

(defn file-remove
  []
  (with-meta
    {:display    "block"
     :text-align "right"
     :color      (theme/color [:file-input :file-remove :fg])}
    {:pseudo
     {:hover
      {:color (theme/color [:file-input :file-remove :hover :fg])}}}))
